export enum SortTypes {
  RECENT = 'rank',
  STOCK = 'qty_available',
}
